import { render, staticRenderFns } from "./Corner.vue?vue&type=template&id=8a678022&scoped=true&"
import script from "./Corner.vue?vue&type=script&lang=js&"
export * from "./Corner.vue?vue&type=script&lang=js&"
import style0 from "./Corner.vue?vue&type=style&index=0&id=8a678022&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a678022",
  null
  
)

export default component.exports